'use strcit';

angular.module('picPreviewShowMoreInfoModule', [])
    .controller('picPreviewShowMoreInfoCtrl', ['$scope', '$modalInstance', '$timeout',
        function ($scope, $modalInstance, $timeout) {
            initStatus();
            initLightGallery();

            /**
             * [initStatus description]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.noWrapSlides = false;
                $scope.slides = [
                    {
                        image: 'http://172.16.25.240/webpic/W0202005/W020200511/W020200511758162142475.JPG',
                        text: '“五一”假期，我区各地在严格落实常态化疫情防控措施的前提下，加快激活疆内旅游市场，实现了疆内旅游市场升温、旅游秩序井然、服务管理到位、旅\n' +
                            '游安全平稳。5月1日— 5日，全疆接待游客440.2万人次。各地在严格落实常态化疫情防控措施的前提下，加快激活疆内旅游市场，实现了疆内旅游市场升温、旅游秩序井然、服务管理到位、各地在严格落实常态化疫情防控措施的前提下，加快激活疆内旅游市场，实现了疆内旅游市场升温、旅游秩序井然、服务管理到位、 '
                    },
                    {
                        image: 'http://172.16.25.240/webpic/W0202005/W020200511/W020200511758162142475.JPG',
                        text: '“五一”假期，我区各地在严格落实常态化疫情防控措施的前提下，加快激活疆内旅游市场，实现了疆内旅游市场升温、旅游秩'
                    },
                    {
                        image: 'http://172.16.25.240/webpic/W0202005/W020200511/W020200511758162142475.JPG',
                        text: '各地在严格落实常态化疫情防控措施的前提下，加快激活疆内旅游市场，实现了疆内旅游市场升温、旅游秩序井然、服务管理到'
                    }
                ];
            }

            /**
             * [cancel description]取消操作
             * @return {[type]} [description]
             */
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };
            function initLightGallery() {
                $timeout(function() {
                    $('#lightgallery').lightGallery();
                });

            }
        }
    ]);
